import def from './_definitions.json';

// eslint-disable-next-line
export default { types: def };
